export const sortChatMessages = (messages) => {
  if (!Array.isArray(messages)) return [];

  return [...messages].sort((a, b) => {
    const aDate = a?.date_created ? new Date(a.date_created).getTime() : NaN;
    const bDate = b?.date_created ? new Date(b.date_created).getTime() : NaN;
    if (!Number.isNaN(aDate) && !Number.isNaN(bDate) && aDate !== bDate) return aDate - bDate;
    if (!Number.isNaN(aDate) && Number.isNaN(bDate)) return -1;
    if (Number.isNaN(aDate) && !Number.isNaN(bDate)) return 1;

    const aOrder = a?.order != null ? Number(a.order) : Number.MAX_SAFE_INTEGER;
    const bOrder = b?.order != null ? Number(b.order) : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) return aOrder - bOrder;

    return String(a?.id ?? '').localeCompare(String(b?.id ?? ''));
  });
};
